export default class PathHelper {
  static getBrickPath(brickPath, brickVersion) {
    if (process.env.NODE_ENV !== 'development') {
      brickPath = `${brickPath}/${brickVersion}`;
    }

    return brickPath;
  }
}



// WEBPACK FOOTER //
// ./src/utils/path-helper.js